<fgb-page-header [pageTitle]="'payment.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'payment.information' | translate"></fgb-banner>

<fgb-payment-nav></fgb-payment-nav>

<div class="container d-none d-lg-block">
  <fgbcl-ecash-description></fgbcl-ecash-description>
  <fgbcl-card-token-list
    [regex]="regex"
    [showExpiry]="true"
    [provider]="provider"
    [redirectUrl]="'/cardtoken/result'"
    [failureUrl]="'/cardtoken/failure'"
    [cardIssuerProvider]="'payment.provider.name' | translate"
  ></fgbcl-card-token-list>
</div>

<div class="container d-block d-lg-none">
  <fgbcl-card-token-list
    [regex]="regex"
    [showExpiry]="true"
    [provider]="provider"
    [redirectUrl]="'/cardtoken/result'"
    [failureUrl]="'/cardtoken/failure'"
    [cardIssuerProvider]="'payment.provider.name' | translate"
  ></fgbcl-card-token-list>
  <fgbcl-ecash-description></fgbcl-ecash-description>
</div>

<div class="container d-none d-lg-block">
  <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
</div>
